import React from "react";
import Loader from "react-loader-spinner";

const PanelLoader = () => {
  return (
    <div className="panel-loader">
      <div className="loader-holder">
        <Loader type="Watch" color="#36bcff" height={40} width={40} />
      </div>
    </div>
  );
};

export default PanelLoader;
